
import Vue from 'vue';
import { Data as HeadlinesData } from '@root/modules/headlines/types/headlines';
import { HeadlineImage } from '@headlines/components/fragments';
import getArticleUrl from '@root/modules/article/utils/buildArticleUrl';
import dayjs from 'dayjs';

interface Props {
  headline: HeadlinesData;
}

interface Computed {
  streamEventStart: string | null;
  articleUrl: string;
}

export default Vue.extend<unknown, unknown, Computed, Props>({
  components: {
    HeadlineImage,
  },
  props: {
    headline: {
      type: Object,
      required: true,
    },
  },
  computed: {
    streamEventStart() {
      const start = this.headline?.attributes?.find((a: { key: string }) => a.key === 'streamEventStart');
      if (!start) return null;

      return dayjs(start.value as string)
        .locale('lt')
        .format('MMMM D [d.] HH:mm')
        .replace(/^./, (c) => c.toUpperCase());
    },
    articleUrl() {
      return getArticleUrl({ article: this.headline as HeadlinesData, domain: this.headline.primaryCategory.channel.url });
    },
  },
});
